<template>
	<div class="ws-page">
		<!-- <div class="ws-page-head">
			<div class="head-title ws-middle">
				<div class="head-tip"></div>
				<span class="head-text">{{title}}</span>
			</div>
			<div class="head-operate">
				<slot name="page_operate"></slot>
			</div>
		</div> -->
		<div class="ws-page-body">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    }
  },
  data() {
    return {

    }
  },
  computed: {
  }
}
</script>

<style scoped>
  .ws-page{
    padding: 15px 0 10px 0;
    box-sizing: border-box;
  }
	.ws-page .ws-page-head {
		line-height: 50px;
		height: 50px;
		background-color: #F3F3F3;
		padding: 0 15px 0 15px;
	}
	.ws-page .ws-page-head .head-title {
		font-size: 14px;
		float: left;
		font-style: normal;
	    font-weight: 400;
	    color: #999999;
	}
	.ws-page .ws-page-head .head-title .head-tip {
		line-height: 20px;
		height: 20px;
		border-left: 5px solid #47cb89;
		margin-right: 5px;
	}
	.ws-page .ws-page-head .head-operate {
		float: right;
	}
	.ws-page .ws-page-body {
    /*padding: 15px 15px 15px 0;*/
    box-sizing: border-box;
    /*background: #fff;*/
	}
</style>



// WEBPACK FOOTER //
// src/components/page/src/page.vue